require("./core/_bootstrap-overrides.less");
require("./variables.less");

require("./components/_admin-configuration.less");
require("./components/_authorized-container.less");
require("./components/_chart.less");
require("./components/_content-container.less");
require("./components/_image.less");
require("./components/_key-manager.less");
require("./components/_logo-container.less");
require("./components/_logo-smartvision.less");
require("./components/_main-header.less");
require("./components/_modal.less");
require("./components/_nav.less");
require("./components/_navigation.less");
require("./components/_sidebar.less");
require("./components/_sidebar-list.less");
require("./components/_sidebar-panel.less");
require("./components/_slider.less");
require("./components/_splitter.less");
require("./components/_system-time.less");
require("./components/_user-menu.less");
require("./components/_user-settings-button.less");


require("./access-nothing.less");
require("./analysis.less");
require("./create-alarm-rule.less");
require("./analysis-filters.less");
require("./env-query-builder-selection.less");
require("./filter-presets.less");
require("./car-view.less");
require("./car-list-view.less");
require("./common.less");
require("./alarm-rule-runs.less");
require("./condition-monitoring.less");
require("./dashboard.less");
require("./gridlets.less");
require("./train-info-panel.less");
require("./highcharts.less");
require("./new-fleet-info.less");
require("./pis.less");
require("./predictive-script-analytics.less");
require("./track-condition.less");
require("./train-software-status.less");
require("./upload-module.less");
require("./webtip.less");

